export default "__VITE_ASSET__f338ca89__"